module.exports = __webpack_public_path__ + "2d97fbc5b8e98f365422da4b14bb3483.pdf";